import {
  XStack,
  Button,
  Separator,
  isWeb,
  YStack,
  SizableText,
  Popover,
  RadioGroupField,
} from '@my/ui'
import { ArrowUpDown } from '@tamagui/lucide-icons'
import { FilterList } from './filter-list'

export interface FilterListProps {
  filters?: FilterOption[]
  onFilterChange: (filter: FilterOption) => void
  activeFilters: FilterOption[]
}
export interface GroupFilterProps extends FilterListProps {
  sortOptions: SortOption[]
  onSortChange: (sortOption: SortOption) => void
  activeSortOption: SortOption | null
}

export type SortOption = {
  label: string
  value: string
}

export type FilterOption = {
  label: string
  value: string
}

export const GroupFilter = ({
  sortOptions,
  onSortChange,
  activeSortOption,
  filters,
  onFilterChange,
  activeFilters,
}: GroupFilterProps) => {
  return (
    <XStack overflow="hidden" width="100%">
      <Popover
        placement="bottom-start"
        isBouncy
        sheetProps={{
          snapPoints: [40],
        }}
        contentProps={{
          padding: '$3.5',
        }}
        trigger={
          <Button
            theme="gray"
            maxWidth={isWeb ? '150px' : '$10'}
            size="$2"
            iconAfter={<ArrowUpDown size={16} />}
            fontWeight="500"
            focusStyle={{
              outlineWidth: 0,
            }}
            $gtSm={{
              size: '$3',
            }}
          >
            <SizableText fow="500" numberOfLines={1} flexShrink={1}>
              {activeSortOption ? activeSortOption.label : 'Sort By'}
            </SizableText>
          </Button>
        }
      >
        <YStack alignItems="flex-start" flex={1}>
          <SizableText fow="500" mb="$2">
            Select sort option
          </SizableText>
          <RadioGroupField
            value={activeSortOption?.value}
            size="$4"
            options={sortOptions}
            onValueChange={(value) => {
              const option = sortOptions.find((item) => item.value === value)
              if (option) {
                onSortChange(option)
              }
            }}
          />
        </YStack>
      </Popover>
      <Separator alignSelf="stretch" bg="$overlay6" borderColor="$overlay6" vertical mx="$2" />
      <FilterList onFilterChange={onFilterChange} filters={filters} activeFilters={activeFilters} />
    </XStack>
  )
}
